// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import RegistrationForm from "./components/RegistrationForm";
import SubscriptionPage from "./components/SubscriptionPage"; // ✅ 구독 페이지 추가
import SubscriptionSuccess from "./components/SubscriptionSuccess";
import SubscriptionCancelled from "./components/SubscriptionCancelled";
import SubscriptionPending from "./components/SubscriptionPending";
import SubscriptionFailed from "./components/SubscriptionFailed";
import SubscriptionError from "./components/SubscriptionError";

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<RegistrationForm />} />
                    <Route path="/subscription" element={<SubscriptionPage />} />
                    <Route path="/subscription-success" element={<SubscriptionSuccess />} />
                    <Route path="/subscription-cancelled" element={<SubscriptionCancelled />} />
                    <Route path="/subscription-pending" element={<SubscriptionPending />} />
                    <Route path="/subscription-failed" element={<SubscriptionFailed />} />
                    <Route path="/subscription-error" element={<SubscriptionError />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
